import * as React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { decode } from "html-entities";

export default function EventItem(props) {
  const system = useSelector((state) => state.systemReducer);
  const event = props.event;

  const itemToggle = () => {
    if (
      props.selectedEvents.filter((item) => {
        return item.nid === event.nid;
      }).length > 0
    ) {
      props.removeSelectedEventItem(event);
    } else {
      props.addSelectedEventItem(event);
    }
  };

  return (
    <div
      key={`event-item-${event.nid}`}
      className={`event-item ${
        props.selectedEvents.filter((item) => {
          return item.nid === event.nid;
        }).length > 0
          ? "selected"
          : ""
      }`}
      onClick={() => itemToggle()}
    >
      {props.selectedEvents.filter((item) => {
        return item.nid === event.nid;
      }).length > 0 && <div className="selected-event-item-marker"></div>}

      {props.selectedEvents.filter((item) => {
        return item.nid === event.nid;
      }).length > 0 && (
        <svg
          className="selected-event-item-marker-check"
          focusable="false"
          aria-hidden="true"
          viewBox="0 0 24 24"
          data-testid="CheckIcon"
        >
          <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
        </svg>
      )}
      <div className="event-item-image">
        <img src={`https://${system.subdomain}.companyapp.net${event.field_featured_image}`} />
      </div>
      <div className="event-item-title">{decode(event.title)}</div>
    </div>
  );
}
